import React from "react";
import { Check } from "lucide-react";

export function Checkbox({ checked, onCheckedChange, className = "", ...props }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label="Vælg"
      onClick={() => onCheckedChange?.(!checked)}
      className={`
        w-5 h-5 rounded-md border flex items-center justify-center 
        transition-colors duration-base
        ${checked ? 'bg-app-primary border-app-primary text-app-primary-text' : 'bg-app-surface border-app-border'}
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[color:var(--color-focus)]
        hover:border-app-border-hover
        ${className}
      `}
      {...props}
    >
      {checked && <Check className="w-3.5 h-3.5 pointer-events-none" />}
    </button>
  );
}